import { defineComponent, h, ref, watch, PropType, shallowRef, isObject } from 'vue';

const iconCache = new Map<IconName, any>();
// 1. 线框风格图标类型定义（严格对照 Ant Design Vue 官网分类）
type IconName = 
  // 一、方向性图标
  | 'StepBackwardOutlined'
  | 'StepForwardOutlined'
  | 'FastBackwardOutlined'
  | 'FastForwardOutlined'
  | 'ShrinkOutlined'
  | 'ArrowsAltOutlined'
  | 'DownOutlined'
  | 'UpOutlined'
  | 'LeftOutlined'
  | 'RightOutlined'
  | 'CaretUpOutlined'
  | 'CaretDownOutlined'
  | 'CaretLeftOutlined'
  | 'CaretRightOutlined'
  | 'UpCircleOutlined'
  | 'DownCircleOutlined'
  | 'LeftCircleOutlined'
  | 'RightCircleOutlined'
  | 'DoubleRightOutlined'
  | 'DoubleLeftOutlined'
  | 'VerticalLeftOutlined'
  | 'VerticalRightOutlined'
  | 'VerticalAlignTopOutlined'
  | 'VerticalAlignMiddleOutlined'
  | 'VerticalAlignBottomOutlined'
  | 'ForwardOutlined'
  | 'BackwardOutlined'
  | 'RollbackOutlined'
  | 'EnterOutlined'
  | 'RetweetOutlined'
  | 'SwapOutlined'
  | 'SwapLeftOutlined'
  | 'SwapRightOutlined'
  | 'ArrowUpOutlined'
  | 'ArrowDownOutlined'
  | 'ArrowLeftOutlined'
  | 'ArrowRightOutlined'
  | 'PlayCircleOutlined'
  | 'UpSquareOutlined'
  | 'DownSquareOutlined'
  | 'LeftSquareOutlined'
  | 'RightSquareOutlined'
  | 'LoginOutlined'
  | 'LogoutOutlined'
  | 'MenuFoldOutlined'
  | 'MenuUnfoldOutlined'
  | 'BorderBottomOutlined'
  | 'BorderHorizontalOutlined'
  | 'BorderInnerOutlined'
  | 'BorderOuterOutlined'
  | 'BorderLeftOutlined'
  | 'BorderRightOutlined'
  | 'BorderTopOutlined'
  | 'BorderVerticleOutlined'
  | 'PicCenterOutlined'
  | 'PicLeftOutlined'
  | 'PicRightOutlined'
  | 'RadiusBottomleftOutlined'
  | 'RadiusBottomrightOutlined'
  | 'RadiusUpleftOutlined'
  | 'RadiusUprightOutlined'
  | 'FullscreenOutlined'
  | 'FullscreenExitOutlined'

  // 二、提示建议性图标
  | 'QuestionOutlined'
  | 'QuestionCircleOutlined'
  | 'PlusOutlined'
  | 'PlusCircleOutlined'
  | 'PauseOutlined'
  | 'PauseCircleOutlined'
  | 'MinusOutlined'
  | 'MinusCircleOutlined'
  | 'PlusSquareOutlined'
  | 'MinusSquareOutlined'
  | 'InfoOutlined'
  | 'InfoCircleOutlined'
  | 'ExclamationOutlined'
  | 'ExclamationCircleOutlined'
  | 'CloseOutlined'
  | 'CloseCircleOutlined'
  | 'CloseSquareOutlined'
  | 'CheckOutlined'
  | 'CheckCircleOutlined'
  | 'CheckSquareOutlined'
  | 'ClockCircleOutlined'
  | 'WarningOutlined'
  | 'IssuesCloseOutlined'
  | 'StopOutlined'

  // 三、编辑类图标
  | 'EditOutlined'
  | 'FormOutlined'
  | 'CopyOutlined'
  | 'ScissorOutlined'
  | 'DeleteOutlined'
  | 'SnippetsOutlined'
  | 'DiffOutlined'
  | 'HighlightOutlined'
  | 'AlignCenterOutlined'
  | 'AlignLeftOutlined'
  | 'AlignRightOutlined'
  | 'BgColorsOutlined'
  | 'BoldOutlined'
  | 'ItalicOutlined'
  | 'UnderlineOutlined'
  | 'StrikethroughOutlined'
  | 'RedoOutlined'
  | 'UndoOutlined'
  | 'ZoomInOutlined'
  | 'ZoomOutOutlined'
  | 'FontColorsOutlined'
  | 'FontSizeOutlined'
  | 'LineHeightOutlined'
  | 'DashOutlined'
  | 'SmallDashOutlined'
  | 'SortAscendingOutlined'
  | 'SortDescendingOutlined'
  | 'DragOutlined'
  | 'OrderedListOutlined'
  | 'UnorderedListOutlined'
  | 'RadiusSettingOutlined'
  | 'ColumnWidthOutlined'
  | 'ColumnHeightOutlined'

  // 四、数据类图标
  | 'AreaChartOutlined'
  | 'PieChartOutlined'
  | 'BarChartOutlined'
  | 'DotChartOutlined'
  | 'LineChartOutlined'
  | 'RadarChartOutlined'
  | 'HeatMapOutlined'
  | 'FallOutlined'
  | 'RiseOutlined'
  | 'StockOutlined'
  | 'BoxPlotOutlined'
  | 'FundOutlined'
  | 'SlidersOutlined'

  // 五、品牌和标识
  | 'AndroidOutlined'
  | 'AppleOutlined'
  | 'WindowsOutlined'
  | 'IeOutlined'
  | 'ChromeOutlined'
  | 'GithubOutlined'
  | 'AliwangwangOutlined'
  | 'DingdingOutlined'
  | 'WeiboSquareOutlined'
  | 'WeiboCircleOutlined'
  | 'TaobaoCircleOutlined'
  | 'Html5Outlined'
  | 'WeiboOutlined'
  | 'TwitterOutlined'
  | 'WechatOutlined'
  | 'YoutubeOutlined'
  | 'AlipayCircleOutlined'
  | 'TaobaoOutlined'
  | 'SkypeOutlined'
  | 'QqOutlined'
  | 'MediumWorkmarkOutlined'
  | 'GitlabOutlined'
  | 'MediumOutlined'
  | 'LinkedinOutlined'
  | 'GooglePlusOutlined'
  | 'DropboxOutlined'
  | 'FacebookOutlined'
  | 'CodepenOutlined'
  | 'CodeSandboxOutlined'
  | 'AmazonOutlined'
  | 'GoogleOutlined'
  | 'CodepenCircleOutlined'
  | 'AlipayOutlined'
  | 'AntDesignOutlined'
  | 'AntCloudOutlined'
  | 'AliyunOutlined'
  | 'ZhihuOutlined'
  | 'SlackOutlined'
  | 'SlackSquareOutlined'
  | 'BehanceOutlined'
  | 'BehanceSquareOutlined'
  | 'DribbbleOutlined'
  | 'DribbbleSquareOutlined'
  | 'InstagramOutlined'
  | 'YuqueOutlined'
  | 'AlibabaOutlined'
  | 'YahooOutlined'
  | 'RedditOutlined'
  | 'SketchOutlined'

  // 六、网站通用图标
  | 'AccountBookOutlined'
  | 'AimOutlined'
  | 'AlertOutlined'
  | 'ApartmentOutlined'
  | 'ApiOutlined'
  | 'AppstoreAddOutlined'
  | 'AppstoreOutlined'
  | 'AudioOutlined'
  | 'AudioMutedOutlined'
  | 'AuditOutlined'
  | 'BankOutlined'
  | 'BarcodeOutlined'
  | 'BarsOutlined'
  | 'BellOutlined'
  | 'BlockOutlined'
  | 'BookOutlined'
  | 'BorderOutlined'
  | 'BorderlessTableOutlined'
  | 'BranchesOutlined'
  | 'BugOutlined'
  | 'BuildOutlined'
  | 'BulbOutlined'
  | 'CalculatorOutlined'
  | 'CalendarOutlined'
  | 'CameraOutlined'
  | 'CarOutlined'
  | 'CarryOutOutlined'
  | 'CiCircleOutlined'
  | 'CiOutlined'
  | 'ClearOutlined'
  | 'CloudDownloadOutlined'
  | 'CloudOutlined'
  | 'CloudServerOutlined'
  | 'CloudSyncOutlined'
  | 'CloudUploadOutlined'
  | 'ClusterOutlined'
  | 'CodeOutlined'
  | 'CoffeeOutlined'
  | 'CommentOutlined'
  | 'CompassOutlined'
  | 'CompressOutlined'
  | 'ConsoleSqlOutlined'
  | 'ContactsOutlined'
  | 'ContainerOutlined'
  | 'ControlOutlined'
  | 'CopyrightCircleOutlined'
  | 'CopyrightOutlined'
  | 'CreditCardOutlined'
  | 'CrownOutlined'
  | 'CustomerServiceOutlined'
  | 'DashboardOutlined'
  | 'DatabaseOutlined'
  | 'DeleteColumnOutlined'
  | 'DeleteRowOutlined'
  | 'DeliveredProcedureOutlined'
  | 'DeploymentUnitOutlined'
  | 'DesktopOutlined'
  | 'DingtalkOutlined'
  | 'DisconnectOutlined'
  | 'DislikeOutlined'
  | 'DollarCircleOutlined'
  | 'DollarOutlined'
  | 'DownloadOutlined'
  | 'EllipsisOutlined'
  | 'EnvironmentOutlined'
  | 'EuroCircleOutlined'
  | 'EuroOutlined'
  | 'ExceptionOutlined'
  | 'ExpandAltOutlined'
  | 'ExpandOutlined'
  | 'ExperimentOutlined'
  | 'ExportOutlined'
  | 'EyeOutlined'
  | 'EyeInvisibleOutlined'
  | 'FieldBinaryOutlined'
  | 'FieldNumberOutlined'
  | 'FieldStringOutlined'
  | 'FieldTimeOutlined'
  | 'FileAddOutlined'
  | 'FileDoneOutlined'
  | 'FileExcelOutlined'
  | 'FileExclamationOutlined'
  | 'FileOutlined'
  | 'FileGifOutlined'
  | 'FileImageOutlined'
  | 'FileJpgOutlined'
  | 'FileMarkdownOutlined'
  | 'FilePdfOutlined'
  | 'FilePptOutlined'
  | 'FileProtectOutlined'
  | 'FileSearchOutlined'
  | 'FileSyncOutlined'
  | 'FileTextOutlined'
  | 'FileUnknownOutlined'
  | 'FileWordOutlined'
  | 'FileZipOutlined'
  | 'FilterOutlined'
  | 'FireOutlined'
  | 'FlagOutlined'
  | 'FolderAddOutlined'
  | 'FolderOutlined'
  | 'FolderOpenOutlined'
  | 'FolderViewOutlined'
  | 'ForkOutlined'
  | 'FormatPainterOutlined'
  | 'FrownOutlined'
  | 'FunctionOutlined'
  | 'FundProjectionScreenOutlined'
  | 'FundViewOutlined'
  | 'FunnelPlotOutlined'
  | 'GatewayOutlined'
  | 'GifOutlined'
  | 'GiftOutlined'
  | 'GlobalOutlined'
  | 'GoldOutlined'
  | 'GroupOutlined'
  | 'HddOutlined'
  | 'HeartOutlined'
  | 'HistoryOutlined'
  | 'HolderOutlined'
  | 'HomeOutlined'
  | 'HourglassOutlined'
  | 'IdcardOutlined'
  | 'ImportOutlined'
  | 'InboxOutlined'
  | 'InsertRowAboveOutlined'
  | 'InsertRowBelowOutlined'
  | 'InsertRowLeftOutlined'
  | 'InsertRowRightOutlined'
  | 'InsuranceOutlined'
  | 'InteractionOutlined'
  | 'KeyOutlined'
  | 'LaptopOutlined'
  | 'LayoutOutlined'
  | 'LikeOutlined'
  | 'LineOutlined'
  | 'LinkOutlined'
  | 'Loading3QuartersOutlined'
  | 'LoadingOutlined'
  | 'LockOutlined'
  | 'MacCommandOutlined'
  | 'MailOutlined'
  | 'ManOutlined'
  | 'MedicineBoxOutlined'
  | 'MehOutlined'
  | 'MenuOutlined'
  | 'MergeCellsOutlined'
  | 'MessageOutlined'
  | 'MobileOutlined'
  | 'MoneyCollectOutlined'
  | 'MonitorOutlined'
  | 'MoreOutlined'
  | 'NodeCollapseOutlined'
  | 'NodeExpandOutlined'
  | 'NodeIndexOutlined'
  | 'NotificationOutlined'
  | 'NumberOutlined'
  | 'OneToOneOutlined'
  | 'PaperClipOutlined'
  | 'PartitionOutlined'
  | 'PayCircleOutlined'
  | 'PercentageOutlined'
  | 'PhoneOutlined'
  | 'PictureOutlined'
  | 'PlaySquareOutlined'
  | 'PoundCircleOutlined'
  | 'PoundOutlined'
  | 'PoweroffOutlined'
  | 'PrinterOutlined'
  | 'ProfileOutlined'
  | 'ProjectOutlined'
  | 'PropertySafetyOutlined'
  | 'PullRequestOutlined'
  | 'PushpinOutlined'
  | 'QrcodeOutlined'
  | 'ReadOutlined'
  | 'ReconciliationOutlined'
  | 'RedEnvelopeOutlined'
  | 'ReloadOutlined'
  | 'RestOutlined'
  | 'RobotOutlined'
  | 'RocketOutlined'
  | 'RotateLeftOutlined'
  | 'RotateRightOutlined'
  | 'SafetyCertificateOutlined'
  | 'SafetyOutlined'
  | 'SaveOutlined'
  | 'ScanOutlined'
  | 'ScheduleOutlined'
  | 'SearchOutlined'
  | 'SecurityScanOutlined'
  | 'SelectOutlined'
  | 'SendOutlined'
  | 'SettingOutlined'
  | 'ShakeOutlined'
  | 'ShareAltOutlined'
  | 'ShopOutlined'
  | 'ShoppingCartOutlined'
  | 'ShoppingOutlined'
  | 'SisternodeOutlined'
  | 'SkinOutlined'
  | 'SmileOutlined'
  | 'SolutionOutlined'
  | 'SoundOutlined'
  | 'SplitCellsOutlined'
  | 'StarOutlined'
  | 'SubnodeOutlined'
  | 'SwitcherOutlined'
  | 'SyncOutlined'
  | 'TableOutlined'
  | 'TabletOutlined'
  | 'TagOutlined'
  | 'TagsOutlined'
  | 'TeamOutlined'
  | 'ThunderboltOutlined'
  | 'ToTopOutlined'
  | 'ToolOutlined'
  | 'TrademarkCircleOutlined'
  | 'TrademarkOutlined'
  | 'TransactionOutlined'
  | 'TranslationOutlined'
  | 'TrophyOutlined'
  | 'UngroupOutlined'
  | 'UnlockOutlined'
  | 'UploadOutlined'
  | 'UsbOutlined'
  | 'UserAddOutlined'
  | 'UserDeleteOutlined'
  | 'UserOutlined'
  | 'UserSwitchOutlined'
  | 'UsergroupAddOutlined'
  | 'UsergroupDeleteOutlined'
  | 'VerifiedOutlined'
  | 'VideoCameraAddOutlined'
  | 'VideoCameraOutlined'
  | 'WalletOutlined'
  | 'WhatsAppOutlined'
  | 'WifiOutlined'
  | 'WomanOutlined';
// 2. 图标动态导入映射（按需加载，未使用不加载）
const iconImportMap: Record<IconName, () => Promise<any>> = {
  // 一、方向性图标
  StepBackwardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.StepBackwardOutlined),
  StepForwardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.StepForwardOutlined),
  FastBackwardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FastBackwardOutlined),
  FastForwardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FastForwardOutlined),
  ShrinkOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ShrinkOutlined),
  ArrowsAltOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ArrowsAltOutlined),
  DownOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DownOutlined),
  UpOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UpOutlined),
  LeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LeftOutlined),
  RightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RightOutlined),
  CaretUpOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CaretUpOutlined),
  CaretDownOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CaretDownOutlined),
  CaretLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CaretLeftOutlined),
  CaretRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CaretRightOutlined),
  UpCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UpCircleOutlined),
  DownCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DownCircleOutlined),
  LeftCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LeftCircleOutlined),
  RightCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RightCircleOutlined),
  DoubleRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DoubleRightOutlined),
  DoubleLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DoubleLeftOutlined),
  VerticalLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VerticalLeftOutlined),
  VerticalRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VerticalRightOutlined),
  VerticalAlignTopOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VerticalAlignTopOutlined),
  VerticalAlignMiddleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VerticalAlignMiddleOutlined),
  VerticalAlignBottomOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VerticalAlignBottomOutlined),
  ForwardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ForwardOutlined),
  BackwardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BackwardOutlined),
  RollbackOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RollbackOutlined),
  EnterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EnterOutlined),
  RetweetOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RetweetOutlined),
  SwapOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SwapOutlined),
  SwapLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SwapLeftOutlined),
  SwapRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SwapRightOutlined),
  ArrowUpOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ArrowUpOutlined),
  ArrowDownOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ArrowDownOutlined),
  ArrowLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ArrowLeftOutlined),
  ArrowRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ArrowRightOutlined),
  PlayCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PlayCircleOutlined),
  UpSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UpSquareOutlined),
  DownSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DownSquareOutlined),
  LeftSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LeftSquareOutlined),
  RightSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RightSquareOutlined),
  LoginOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LoginOutlined),
  LogoutOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LogoutOutlined),
  MenuFoldOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MenuFoldOutlined),
  MenuUnfoldOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MenuUnfoldOutlined),
  BorderBottomOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderBottomOutlined),
  BorderHorizontalOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderHorizontalOutlined),
  BorderInnerOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderInnerOutlined),
  BorderOuterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderOuterOutlined),
  BorderLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderLeftOutlined),
  BorderRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderRightOutlined),
  BorderTopOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderTopOutlined),
  BorderVerticleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderVerticleOutlined),
  PicCenterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PicCenterOutlined),
  PicLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PicLeftOutlined),
  PicRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PicRightOutlined),
  RadiusBottomleftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RadiusBottomleftOutlined),
  RadiusBottomrightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RadiusBottomrightOutlined),
  RadiusUpleftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RadiusUpleftOutlined),
  RadiusUprightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RadiusUprightOutlined),
  FullscreenOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FullscreenOutlined),
  FullscreenExitOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FullscreenExitOutlined),

  // 二、提示建议性图标
  QuestionOutlined: () => import('@ant-design/icons-vue').then(mod => mod.QuestionOutlined),
  QuestionCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.QuestionCircleOutlined),
  PlusOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PlusOutlined),
  PlusCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PlusCircleOutlined),
  PauseOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PauseOutlined),
  PauseCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PauseCircleOutlined),
  MinusOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MinusOutlined),
  MinusCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MinusCircleOutlined),
  PlusSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PlusSquareOutlined),
  MinusSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MinusSquareOutlined),
  InfoOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InfoOutlined),
  InfoCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InfoCircleOutlined),
  ExclamationOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ExclamationOutlined),
  ExclamationCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ExclamationCircleOutlined),
  CloseOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloseOutlined),
  CloseCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloseCircleOutlined),
  CloseSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloseSquareOutlined),
  CheckOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CheckOutlined),
  CheckCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CheckCircleOutlined),
  CheckSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CheckSquareOutlined),
  ClockCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ClockCircleOutlined),
  WarningOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WarningOutlined),
  IssuesCloseOutlined: () => import('@ant-design/icons-vue').then(mod => mod.IssuesCloseOutlined),
  StopOutlined: () => import('@ant-design/icons-vue').then(mod => mod.StopOutlined),

  // 三、编辑类图标
  EditOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EditOutlined),
  FormOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FormOutlined),
  CopyOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CopyOutlined),
  ScissorOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ScissorOutlined),
  DeleteOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DeleteOutlined),
  SnippetsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SnippetsOutlined),
  DiffOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DiffOutlined),
  HighlightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HighlightOutlined),
  AlignCenterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AlignCenterOutlined),
  AlignLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AlignLeftOutlined),
  AlignRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AlignRightOutlined),
  BgColorsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BgColorsOutlined),
  BoldOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BoldOutlined),
  ItalicOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ItalicOutlined),
  UnderlineOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UnderlineOutlined),
  StrikethroughOutlined: () => import('@ant-design/icons-vue').then(mod => mod.StrikethroughOutlined),
  RedoOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RedoOutlined),
  UndoOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UndoOutlined),
  ZoomInOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ZoomInOutlined),
  ZoomOutOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ZoomOutOutlined),
  FontColorsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FontColorsOutlined),
  FontSizeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FontSizeOutlined),
  LineHeightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LineHeightOutlined),
  DashOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DashOutlined),
  SmallDashOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SmallDashOutlined),
  SortAscendingOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SortAscendingOutlined),
  SortDescendingOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SortDescendingOutlined),
  DragOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DragOutlined),
  OrderedListOutlined: () => import('@ant-design/icons-vue').then(mod => mod.OrderedListOutlined),
  UnorderedListOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UnorderedListOutlined),
  RadiusSettingOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RadiusSettingOutlined),
  ColumnWidthOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ColumnWidthOutlined),
  ColumnHeightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ColumnHeightOutlined),

  // 四、数据类图标
  AreaChartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AreaChartOutlined),
  PieChartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PieChartOutlined),
  BarChartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BarChartOutlined),
  DotChartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DotChartOutlined),
  LineChartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LineChartOutlined),
  RadarChartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RadarChartOutlined),
  HeatMapOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HeatMapOutlined),
  FallOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FallOutlined),
  RiseOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RiseOutlined),
  StockOutlined: () => import('@ant-design/icons-vue').then(mod => mod.StockOutlined),
  BoxPlotOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BoxPlotOutlined),
  FundOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FundOutlined),
  SlidersOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SlidersOutlined),

  // 五、品牌和标识（仅保留官网列出的线框图标）
  AndroidOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AndroidOutlined),
  AppleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AppleOutlined),
  WindowsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WindowsOutlined),
  IeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.IeOutlined),
  ChromeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ChromeOutlined),
  GithubOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GithubOutlined),
  AliwangwangOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AliwangwangOutlined),
  DingdingOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DingdingOutlined),
  WeiboSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WeiboSquareOutlined),
  WeiboCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WeiboCircleOutlined),
  TaobaoCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TaobaoCircleOutlined),
  Html5Outlined: () => import('@ant-design/icons-vue').then(mod => mod.Html5Outlined),
  WeiboOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WeiboOutlined),
  TwitterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TwitterOutlined),
  WechatOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WechatOutlined),
  YoutubeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.YoutubeOutlined),
  AlipayCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AlipayCircleOutlined),
  TaobaoOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TaobaoOutlined),
  SkypeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SkypeOutlined),
  QqOutlined: () => import('@ant-design/icons-vue').then(mod => mod.QqOutlined),
  MediumWorkmarkOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MediumWorkmarkOutlined),
  GitlabOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GitlabOutlined),
  MediumOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MediumOutlined),
  LinkedinOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LinkedinOutlined),
  GooglePlusOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GooglePlusOutlined),
  DropboxOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DropboxOutlined),
  FacebookOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FacebookOutlined),
  CodepenOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CodepenOutlined),
  CodeSandboxOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CodeSandboxOutlined),
  AmazonOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AmazonOutlined),
  GoogleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GoogleOutlined),
  CodepenCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CodepenCircleOutlined),
  AlipayOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AlipayOutlined),
  AntDesignOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AntDesignOutlined),
  AntCloudOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AntCloudOutlined),
  AliyunOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AliyunOutlined),
  ZhihuOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ZhihuOutlined),
  SlackOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SlackOutlined),
  SlackSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SlackSquareOutlined),
  BehanceOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BehanceOutlined),
  BehanceSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BehanceSquareOutlined),
  DribbbleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DribbbleOutlined),
  DribbbleSquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DribbbleSquareOutlined),
  InstagramOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InstagramOutlined),
  YuqueOutlined: () => import('@ant-design/icons-vue').then(mod => mod.YuqueOutlined),
  AlibabaOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AlibabaOutlined),
  YahooOutlined: () => import('@ant-design/icons-vue').then(mod => mod.YahooOutlined),
  RedditOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RedditOutlined),
  SketchOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SketchOutlined),

  // 六、网站通用图标（按官网顺序整理）
  // 在「六、网站通用图标」最顶部补充（HomeOutlined 之前）
AccountBookOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AccountBookOutlined),
AimOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AimOutlined),
AlertOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AlertOutlined),
ApartmentOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ApartmentOutlined),
ApiOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ApiOutlined),
AppstoreAddOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AppstoreAddOutlined),
AppstoreOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AppstoreOutlined),
AudioOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AudioOutlined),
AudioMutedOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AudioMutedOutlined),
AuditOutlined: () => import('@ant-design/icons-vue').then(mod => mod.AuditOutlined),
BankOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BankOutlined),
BarcodeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BarcodeOutlined),
BarsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BarsOutlined),
BellOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BellOutlined),
BlockOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BlockOutlined),
BookOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BookOutlined),
BorderOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderOutlined),
BorderlessTableOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BorderlessTableOutlined),
BranchesOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BranchesOutlined),
BugOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BugOutlined),
BuildOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BuildOutlined),
BulbOutlined: () => import('@ant-design/icons-vue').then(mod => mod.BulbOutlined),
CalculatorOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CalculatorOutlined),
CalendarOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CalendarOutlined),
CameraOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CameraOutlined),
CarOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CarOutlined),
CarryOutOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CarryOutOutlined),
CiCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CiCircleOutlined),
CiOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CiOutlined),
ClearOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ClearOutlined),
CloudDownloadOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloudDownloadOutlined),
CloudOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloudOutlined),
CloudServerOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloudServerOutlined),
CloudSyncOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloudSyncOutlined),
CloudUploadOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CloudUploadOutlined),
ClusterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ClusterOutlined),
CodeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CodeOutlined),
CoffeeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CoffeeOutlined),
CommentOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CommentOutlined),
CompassOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CompassOutlined),
CompressOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CompressOutlined),
ConsoleSqlOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ConsoleSqlOutlined),
ContactsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ContactsOutlined),
ContainerOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ContainerOutlined),
ControlOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ControlOutlined),
CopyrightCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CopyrightCircleOutlined),
CopyrightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CopyrightOutlined),
CreditCardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CreditCardOutlined),
CrownOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CrownOutlined),
CustomerServiceOutlined: () => import('@ant-design/icons-vue').then(mod => mod.CustomerServiceOutlined),
DashboardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DashboardOutlined),
DatabaseOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DatabaseOutlined),
DeleteColumnOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DeleteColumnOutlined),
DeleteRowOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DeleteRowOutlined),
DeliveredProcedureOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DeliveredProcedureOutlined),
DeploymentUnitOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DeploymentUnitOutlined),
DesktopOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DesktopOutlined),
DingtalkOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DingtalkOutlined),
DisconnectOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DisconnectOutlined),
DislikeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DislikeOutlined),
DollarCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DollarCircleOutlined),
DollarOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DollarOutlined),
EllipsisOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EllipsisOutlined),
EnvironmentOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EnvironmentOutlined),
EuroCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EuroCircleOutlined),
EuroOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EuroOutlined),
ExceptionOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ExceptionOutlined),
ExpandAltOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ExpandAltOutlined),
ExpandOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ExpandOutlined),
ExperimentOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ExperimentOutlined),
ExportOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ExportOutlined),
EyeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EyeOutlined),
EyeInvisibleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.EyeInvisibleOutlined),
FieldBinaryOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FieldBinaryOutlined),
FieldNumberOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FieldNumberOutlined),
FieldStringOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FieldStringOutlined),
FieldTimeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FieldTimeOutlined),
FileAddOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileAddOutlined),
FileDoneOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileDoneOutlined),
FileExcelOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileExcelOutlined),
FileExclamationOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileExclamationOutlined),
FileOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileOutlined),
FileGifOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileGifOutlined),
FileImageOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileImageOutlined),
FileJpgOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileJpgOutlined),
FileMarkdownOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileMarkdownOutlined),
FilePdfOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FilePdfOutlined),
FilePptOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FilePptOutlined),
FileProtectOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileProtectOutlined),
FileSearchOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileSearchOutlined),
FileSyncOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileSyncOutlined),
FileTextOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileTextOutlined),
FileUnknownOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileUnknownOutlined),
FileWordOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileWordOutlined),
FileZipOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FileZipOutlined),
FilterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FilterOutlined),
FireOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FireOutlined),
FlagOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FlagOutlined),
FolderAddOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FolderAddOutlined),
FolderOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FolderOutlined),
FolderOpenOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FolderOpenOutlined),
FolderViewOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FolderViewOutlined),
ForkOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ForkOutlined),
FormatPainterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FormatPainterOutlined),
FrownOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FrownOutlined),
FunctionOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FunctionOutlined),
FundProjectionScreenOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FundProjectionScreenOutlined),
FundViewOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FundViewOutlined),
FunnelPlotOutlined: () => import('@ant-design/icons-vue').then(mod => mod.FunnelPlotOutlined),
GatewayOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GatewayOutlined),
GifOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GifOutlined),
GiftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GiftOutlined),
GlobalOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GlobalOutlined),
GoldOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GoldOutlined),
GroupOutlined: () => import('@ant-design/icons-vue').then(mod => mod.GroupOutlined),
HddOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HddOutlined),
HeartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HeartOutlined),
HistoryOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HistoryOutlined),
HolderOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HolderOutlined),
HomeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HomeOutlined),
HourglassOutlined: () => import('@ant-design/icons-vue').then(mod => mod.HourglassOutlined),
IdcardOutlined: () => import('@ant-design/icons-vue').then(mod => mod.IdcardOutlined),
ImportOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ImportOutlined),
InboxOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InboxOutlined),
InsertRowAboveOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InsertRowAboveOutlined),
InsertRowBelowOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InsertRowBelowOutlined),
InsertRowLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InsertRowLeftOutlined),
InsertRowRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InsertRowRightOutlined),
InsuranceOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InsuranceOutlined),
InteractionOutlined: () => import('@ant-design/icons-vue').then(mod => mod.InteractionOutlined),
KeyOutlined: () => import('@ant-design/icons-vue').then(mod => mod.KeyOutlined),
LaptopOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LaptopOutlined),
LayoutOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LayoutOutlined),
LikeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LikeOutlined),
LineOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LineOutlined),
LinkOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LinkOutlined),
Loading3QuartersOutlined: () => import('@ant-design/icons-vue').then(mod => mod.Loading3QuartersOutlined),
LoadingOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LoadingOutlined),
LockOutlined: () => import('@ant-design/icons-vue').then(mod => mod.LockOutlined),
MacCommandOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MacCommandOutlined),
MailOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MailOutlined),
ManOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ManOutlined),
MedicineBoxOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MedicineBoxOutlined),
MehOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MehOutlined),
MenuOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MenuOutlined),
MergeCellsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MergeCellsOutlined),
MessageOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MessageOutlined),
MobileOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MobileOutlined),
MoneyCollectOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MoneyCollectOutlined),
MonitorOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MonitorOutlined),
MoreOutlined: () => import('@ant-design/icons-vue').then(mod => mod.MoreOutlined),
NodeCollapseOutlined: () => import('@ant-design/icons-vue').then(mod => mod.NodeCollapseOutlined),
NodeExpandOutlined: () => import('@ant-design/icons-vue').then(mod => mod.NodeExpandOutlined),
NodeIndexOutlined: () => import('@ant-design/icons-vue').then(mod => mod.NodeIndexOutlined),
NotificationOutlined: () => import('@ant-design/icons-vue').then(mod => mod.NotificationOutlined),
NumberOutlined: () => import('@ant-design/icons-vue').then(mod => mod.NumberOutlined),
OneToOneOutlined: () => import('@ant-design/icons-vue').then(mod => mod.OneToOneOutlined),
PaperClipOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PaperClipOutlined),
PartitionOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PartitionOutlined),
PayCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PayCircleOutlined),
PercentageOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PercentageOutlined),
PhoneOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PhoneOutlined),
PictureOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PictureOutlined),
PlaySquareOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PlaySquareOutlined),
PoundCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PoundCircleOutlined),
PoundOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PoundOutlined),
PoweroffOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PoweroffOutlined),
PrinterOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PrinterOutlined),
ProfileOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ProfileOutlined),
ProjectOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ProjectOutlined),
PropertySafetyOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PropertySafetyOutlined),
PullRequestOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PullRequestOutlined),
PushpinOutlined: () => import('@ant-design/icons-vue').then(mod => mod.PushpinOutlined),
QrcodeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.QrcodeOutlined),
ReadOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ReadOutlined),
ReconciliationOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ReconciliationOutlined),
RedEnvelopeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RedEnvelopeOutlined),
ReloadOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ReloadOutlined),
RestOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RestOutlined),
RobotOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RobotOutlined),
RocketOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RocketOutlined),
RotateLeftOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RotateLeftOutlined),
RotateRightOutlined: () => import('@ant-design/icons-vue').then(mod => mod.RotateRightOutlined),
SafetyCertificateOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SafetyCertificateOutlined),
SafetyOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SafetyOutlined),
SaveOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SaveOutlined),
ScanOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ScanOutlined),
ScheduleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ScheduleOutlined),
SearchOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SearchOutlined),
SecurityScanOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SecurityScanOutlined),
SelectOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SelectOutlined),
SendOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SendOutlined),
SettingOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SettingOutlined),
ShakeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ShakeOutlined),
ShareAltOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ShareAltOutlined),
ShopOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ShopOutlined),
ShoppingCartOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ShoppingCartOutlined),
ShoppingOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ShoppingOutlined),
SisternodeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SisternodeOutlined),
SkinOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SkinOutlined),
SmileOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SmileOutlined),
SolutionOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SolutionOutlined),
SoundOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SoundOutlined),
SplitCellsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SplitCellsOutlined),
StarOutlined: () => import('@ant-design/icons-vue').then(mod => mod.StarOutlined),
SubnodeOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SubnodeOutlined),
SwitcherOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SwitcherOutlined),
SyncOutlined: () => import('@ant-design/icons-vue').then(mod => mod.SyncOutlined),
TableOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TableOutlined),
TabletOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TabletOutlined),
TagOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TagOutlined),
TagsOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TagsOutlined),
TeamOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TeamOutlined),
ThunderboltOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ThunderboltOutlined),
ToTopOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ToTopOutlined),
ToolOutlined: () => import('@ant-design/icons-vue').then(mod => mod.ToolOutlined),
TrademarkCircleOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TrademarkCircleOutlined),
TrademarkOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TrademarkOutlined),
TransactionOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TransactionOutlined),
TranslationOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TranslationOutlined),
TrophyOutlined: () => import('@ant-design/icons-vue').then(mod => mod.TrophyOutlined),
UngroupOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UngroupOutlined),
UnlockOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UnlockOutlined),
UploadOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UploadOutlined),
UsbOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UsbOutlined),
UserAddOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UserAddOutlined),
UserDeleteOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UserDeleteOutlined),
UserOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UserOutlined),
UserSwitchOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UserSwitchOutlined),
UsergroupAddOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UsergroupAddOutlined),
UsergroupDeleteOutlined: () => import('@ant-design/icons-vue').then(mod => mod.UsergroupDeleteOutlined),
VerifiedOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VerifiedOutlined),
VideoCameraAddOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VideoCameraAddOutlined),
VideoCameraOutlined: () => import('@ant-design/icons-vue').then(mod => mod.VideoCameraOutlined),
WalletOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WalletOutlined),
WhatsAppOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WhatsAppOutlined),
WifiOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WifiOutlined),
WomanOutlined: () => import('@ant-design/icons-vue').then(mod => mod.WomanOutlined),
DownloadOutlined: () => import('@ant-design/icons-vue').then(mod => mod.DownloadOutlined),
};

// 3. 图标配置类型（不变）
// ===================== 2. 图标配置类型（保持不变） =====================
export type IconOptions = {
  name?: IconName;
  svgPath?: string;
  size?: number;
  iconSize?: number;
  color?: string;
  bgColor?: string;
  border?: boolean;
  borderWidth?: number;
  borderColor?: string;
  borderRadius?: number;
  wrapperStyle?: Record<string, string>;
  iconStyle?: Record<string, string>;
};

// ===================== 3. 核心 Icon 组件（已兼容裸写 #xxx 颜色值） =====================
const Icon = defineComponent({
  name: 'Icon',       // 保留大驼峰组件名
  alias: 'icon',      // 关键：添加别名，支持 <icon> 标签
  props: {
    name: { 
      type: String as PropType<IconName>, 
      default: undefined,
      validator: (val: string): val is IconName => { 
        return !!val && val in iconImportMap;
      }
    },
    svgPath: { type: String, default: undefined },
    size: { 
      type: [Number, String], // 核心：允许数字和字符串类型
      default: 16,
      coerce: (val) => Number(val), // 自动转为数字供内部使用
      validator: (val: any) => {
        // 校验：确保值能转为合法数字
        const num = Number(val);
        return !isNaN(num) && num > 0; // 额外校验数字为正数（可选）
      }
    },
    iconSize: { type: Number, default: undefined },
    color: { 
      type: String, 
      default: '#333',
      // 校验：允许字符串或合法的 #xxx 颜色格式
      validator: (val: any) => {
        return typeof val === 'string' || /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(String(val));
      }
    },
    bgColor: { type: String, default: 'transparent' },
    border: { type: Boolean, default: false },
    borderWidth: { type: Number, default: 1 },
    borderColor: { type: String, default: '#828282' },
    borderRadius: { type: Number, default: 0 },
    wrapperStyle: { type: Object as PropType<Record<string, string>>, default: () => ({}) },
    iconStyle: { type: Object as PropType<Record<string, string>>, default: () => ({}) },
    // 支持 class 属性（适配模板调用）
    class: { type: String, default: '' },
    // 支持原生 style 属性（优先级高于 wrapperStyle）
    style: { type: Object as PropType<Record<string, string>>, default: () => ({}) }
  },
  setup(props) {
    // 1. 改用 shallowRef 减少响应式开销，提升渲染性能
    const iconComp = shallowRef<any>(null);
    // 2. 全局缓存已加载的图标，避免 Tree 节点重复加载
    const iconCache = (globalThis as any).iconCache || new Map<IconName, any>();
    (globalThis as any).iconCache = iconCache;
    // 3. 加载状态标记，防止并发请求和重复加载
    const isLoading = shallowRef(false);

    // 处理颜色值：确保始终返回合法的字符串格式（兼容裸写 #xxx）
    const getColor = () => {
      const color = String(props.color).trim();
      return color.startsWith('#') ? color : props.color;
    };

    // 优化后的动态加载逻辑：优先读缓存，避免重复异步加载
    const loadIcon = async () => {
      if (!props.name || !iconImportMap[props.name]) { 
        console.warn(`图标 ${props.name} 未注册，请检查 IconName 类型和 iconImportMap 映射`);
        iconComp.value = () => null; // 改为空函数，避免 Vue 内部校验非对象
        isLoading.value = false;
        return;
      }

      // 优先使用缓存，避免 Tree 节点复用/更新时重复加载
      if (iconCache.has(props.name)) {
        iconComp.value = iconCache.get(props.name);
        isLoading.value = false;
        return;
      }

      // 防止并发请求（Tree 渲染时可能批量触发）
      if (isLoading.value) return;
      isLoading.value = true;

      try {
        const iconModule = await iconImportMap[props.name]();
        // 关键：AntD 图标模块导出可能是 { default: 组件 } 或直接导出组件，统一提取
        const RealIconComp = iconModule.default || iconModule;
        iconComp.value = RealIconComp;
        iconCache.set(props.name, RealIconComp); // 缓存真实组件      
      } catch (e) {
        console.error(`加载图标 ${props.name} 失败：`, e);
        iconComp.value = null;
      } finally {
        isLoading.value = false;
      }
    };

    // 优化 watch 逻辑：延迟执行 + 关闭深度监听，减少 Tree 渲染时的竞态
    watch(() => props.name, loadIcon, { 
      immediate: true,
      flush: 'post', // 延迟到 DOM 更新后执行，避免闪烁
      deep: false
    });

    return () => {
      // 合并样式：原生 style > wrapperStyle > 默认样式
      const wrapperStyles = {
        width: `${props.size}px`,
        height: `${props.size}px`,
        lineHeight: `${props.size}px`,
        background: props.bgColor,
        border: props.border ? `${props.borderWidth}px solid ${props.borderColor}` : 'none',
        borderRadius: `${props.borderRadius}px`,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        flexShrink: '0',
        ...props.wrapperStyle,
        ...props.style // 原生 style 优先级更高
      };

      const iconStyles = {
        fontSize: `${props.iconSize || props.size}px`,
        color: getColor(), // 使用处理后的颜色值
        flexShrink: '0',
        ...props.iconStyle,
      };

      // 渲染逻辑：加载中不渲染空节点，避免 Tree 布局跳动
      return h('span', {
        class: `custom-icon ${props.class}`, // 合并自定义 class
        style: wrapperStyles
      }, [
        // 仅在加载完成后渲染图标，避免闪烁
        !isLoading.value && iconComp.value && h(iconComp.value, { style: iconStyles }),
        // 降级渲染自定义 SVG 路径（同样避免加载中渲染）
        !isLoading.value && !iconComp.value && props.svgPath && h('svg', {
          width: props.iconSize || props.size,
          height: props.iconSize || props.size,
          fill: getColor(), // SVG 填充色也使用处理后的颜色
          viewBox: '0 0 1024 1024',
          style: iconStyles
        }, [
          h('path', { d: props.svgPath })
        ])
      ]);
    };
  },
});



// ===================== 4. 调用工具函数（保持不变） =====================
export const icon = (options: IconOptions) => {
  return () => h(Icon, options);
};

// ===================== 5. 全局注册辅助函数（简化 main.ts 注册） =====================
export const registerIcon = (app: any) => {
  app.component('Icon', Icon);
  app.component('icon', Icon); // 显式注册小写标签名，兼容低版本 Vue
};

//菜单图标调用实例
// ,icon: icon({  name:'DownloadOutlined',  size: 16,  color: '#ff00ff'})

export default Icon;